<template>
    <div class="index">

        <!-- 資料讀取中 -->
        <div id="mask" class="hide">
            <div class="text">
                <i class="fas fa-spinner fa-pulse"></i> 資料讀取中
            </div>
        </div>

        <!-- 情報站 -->
        <section>
            <b-container>
                <b-row align-h="center" cols="1" cols-sm="2" cols-md="3" class="index-link-group">
                    <b-col v-for="(item, index) in stationData" :key="index">
                        <b-button variant="link" class="index-link-item" :href="item.url" @click="total(item.url)">
                            <div class="index-link-pic"><b-img :src="item.src" fluid></b-img></div>
                            <div class="index-link-title">{{ item.title }}</div>
                        </b-button>
                    </b-col>    
                </b-row>
            </b-container>

        </section>

        <!-- 智慧農業成果 -->
        <!--
        <section class="bg-gray agri-result-group" style="display: none;">
            <b-container>
                <h2>智慧農業成果</h2>
                <b-row cols="1" class="py-3">
                    <carousel :autoplay="true" :loop="true" :nav="false" :responsive="{0:{items: 1},768:{items: 2},992:{items: 3}}" style="width: 100%;" v-if="farmData">
                    <b-col v-for="(data, index) in farmData" :key="index">
                        <b-link class="agri-result-item drop-shadow" :href="data.url">
                            <div class="agri-result-pic">
                                <b-img :src="data.src" fluid></b-img>
                            </div>
                            <div class="agri-result-info">
                                <h3 class="agri-result-title">{{ data.title }}</h3>
                                <div class="agri-result-content"> {{ data.content }} </div>
                            </div>
                        </b-link>
                    </b-col>
                    </carousel>
                </b-row>

                <b-row class="justify-content-center pt-1">
                    <b-col cols="auto"><b-button pill variant="primary" to="Farm" class="px-4">更多智慧農業成果</b-button></b-col>
                </b-row>
            </b-container>
        </section>
        -->
        <!-- 智慧農業成果 -->
        <!--
        <section class="bg-gray agri-result-group">
            <b-container>
                <h2>智慧農場</h2>
                <b-row cols="1" class="py-3">
                    <carousel :autoplay="true" :margin="10" :loop="true" :nav="false" :dots="false" :responsive="{0:{items: 1},768:{items: 2},992:{items: 4}}" v-if="farmData2">
                    <b-col v-for="(data, index) in farmData2" :key="index">
                        <b-link :to="data.url" class="agri-result-item drop-shadow">
                            <div class="agri-result-pic">
                                <b-img :src="data.src"  fluid></b-img>
                            </div>
                            <div class="agri-result-info">
                                <h3 class="agri-result-title">{{ data.title }}</h3>
                            </div>
                        </b-link>
                    </b-col>
                </carousel>
                </b-row>
            </b-container>
        </section>
        -->
        

        <!-- 氣象觀測家 -->
        <section class="weather-viewer">
            <b-container>
                <b-row cols="1" md="2" lg="2" xl="2" align-h="between">
                    <b-col cols="auto"><h2>氣象觀測家</h2></b-col>
                    <b-col cols="auto" align-self="center">                        
                        <div class="weather-info">
                            <span class="mr-4">
                                <span class="num">{{ weather.date }}</span> {{ weather.place }}</span>
                            <span class="mr-4"><span class="icon-thermometer-hot mr-1"></span><span class="num">{{ weather.MinT }}-{{ weather.MaxT }}℃</span></span>
                            <span class="icon-rain mr-1"></span><span class="num">{{ weather.PoP }}%</span>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="py-3">
                    <b-col v-for="(item, index) in meteorData" :key="index">
                        <button class="btn btn-block" :class="meteorIndex === item.disaster?(item.color == 'danger' ? 'btn-red active' : 'btn-yellow active'):(item.color == 'danger' ? 'btn-red' : 'btn-yellow')"
                            @click="setmeteorIndex(item.disaster, 'data', item.color)">{{ item.disaster }}</button>
                    </b-col>
                </b-row>
                <div class="alert-msg-group" v-for="(item, index) in meteorData" :key="index" v-show="meteorIndex === item.disaster && showmeteor">
                    <div class="alert-msg-header">
                        <div class="alert-msg-title">{{ item.affect }}</div>
                        <div><button class="btn" @click="closemeteor()"><span class="icon-cross"></span></button></div>
                    </div>
                    <div class="alert-msg-main">
                        <div class="alert-msg-btn">
                            <carousel :autoplay="false" :loop="false" :nav="false" style="width: 100%;" v-if="item.datas"
                                :responsive="{0:{items: 2},335:{items: 3},435:{items: 4},535:{items: 5},735:{items: 6},935:{items: 8},1035:{items: 10}}">
                                <button class="btn btn-round" :class="index_detail == meteorDataIndex?(item.color == 'warning' ? 'btn-yellow active' : 'btn-red active'):(item.color == 'warning' ? 'btn-yellow  ' : 'btn-red ')"
                                    v-for="(item_detail, index_detail) in item.datas" :key="index_detail"
                                    @click="setmeteorIndex(index_detail, 'detail', '')">{{ item_detail.crop }}</button>
                            </carousel>
                        </div>
                        <div class="alert-msg-btn-detil" v-for="(item_detail, index_detail) in item.datas"
                            :key="index_detail" v-show="index_detail == meteorDataIndex">
                            {{ item_detail.content }}
                        </div>
                        <b-row align-h="end">
                            <b-col cols="auto"><b-button pill variant="primary" class="px-4"
                                    href="#/Gis">詳細資訊</b-button></b-col>
                        </b-row>
                    </div>
                </div>
                資料來源網址：<a target="_blank" href="https://agri-data.kcg.gov.tw/api.html?vp=1#">高雄農來訊資訊服務</a>
            </b-container>
        </section>

        <!-- 甘藍產銷預警分析 -->
        <section class="warning-group bg-gray">
            <b-container>
                <h2>甘藍產銷預警分析</h2>
                <div class="table-responsive shadow rounded-xl scrollStyle">
                    <table class="table">
                        <thead class="bg-primary">
                            <tr>
                                <th scope="col">日期</th>                                
                                <th scope="col" colspan="3" v-for="(item, index) in titleData" :key="index">{{ item }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in coltitle" :key="index">
                                <th scope="row">{{ item }}</th>
                                <td v-for="(item_detail, indexdetail) in tableData" :key="indexdetail">
                                    <b-badge v-if="index == 0"
                                        :class="item_detail.season == '上旬' ? 'bg-lightgreen' : item_detail.season == '中旬' ? 'bg-blue' : 'bg-earthyyellow'">
                                        {{ item_detail.season }}
                                    </b-badge>
                                    <div v-else-if="index == 1">{{ item_detail.estimate_value }}</div>
                                    <b-icon icon="circle-fill" font-scale="1.3" v-else-if="index == 2" :variant="item_detail.warning_light == 'green' ? 'success' :
                                        item_detail.warning_light == 'red' ? 'danger' :
                                            item_detail.warning_light == 'yellow' ? 'warning' : ' color-purple'">
                                    </b-icon>
                                    <div v-else-if="index == 3">{{ item_detail.harvesting }}</div>
                                    <div v-else-if="index == 4">{{ item_detail.ave_value_yoy_in_3yrs }}</div>
                                    <div v-else-if="index == 5">{{ item_detail.persent_yoy_in_3yrs }}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="bg-white rounded-lg px-3 pt-3 pb-1">
                    <ul class="list-unstyled">
                        <li><strong>說明1：</strong>甘藍每公頃種植約30,000株。</li>
                        <li><strong>說明2：</strong>390萬株以下為綠色燈號<b-icon icon="circle-fill" variant="success"></b-icon>，390-540萬株為黃色燈號<b-icon icon="circle-fill" variant="warning"></b-icon>，當達540-600萬株時為紅色燈號(警戒值)<b-icon icon="circle-fill" variant="danger"></b-icon>，600萬株以上為紫色燈號(超種)<b-icon icon="circle-fill" class="color-purple"></b-icon>。</li>
                        <li><strong>說明3：</strong>資料更新時間為每年8月至隔年2月播種期</li>
                    </ul>
                </div>
                資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=KAKZOiDQJfKu">農業部農業資料開放平台</a>
            </b-container>

        </section>

        <!-- 農價趨勢觀察家 -->
        <section class="price-group">
            <b-container>
                <b-row>
                    <b-col cols="12" md="12" lg="4"><h2>農價趨勢觀察家</h2></b-col>
                    <b-col cols="12" md="12" lg="8" class="pt-3">
                        <b-row cols="1" cols-md="2" cols-lg="2" cols-xl="2">
                            <b-col class="pb-3">
                                <div class="price-item up-price">
                                    <div class="price-item-title">
                                        <span class="icon-arrow-up mr-2"></span>漲勢作物
                                    </div>
                                    <div class="price-item-block scrollStyle">                                        
                                        <div class="price-list" v-for="(item, index) in upData" :key="index" @click="getCropTradeDay9(item.crop)">
                                            <div class="price-list-vege">{{ item.crop }}</div>
                                            <div class="price-list-price">{{ item.avg }}元/公斤</div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col class="pb-3">
                                <div class="price-item down-price">
                                    <div class="price-item-title">
                                        <span class="icon-arrow-down mr-2"></span>跌勢作物
                                    </div>
                                    <div class="price-item-block scrollStyle">
                                        <div class="price-list" v-for="(item, index) in downData" :key="index" @click="getCropTradeDay9(item.crop)">
                                            <div class="price-list-vege">{{ item.crop }}</div>
                                            <div class="price-list-price">{{ item.avg }}/公斤</div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <ul class="mb-0 text-shadow-white list-unstyled">
                            <li>漲跌勢判斷以RSV>80為漲勢、&lt;20為跌勢</li>
                            <li>RSV=((加權平均-最近9日最低均價) /(最近9天最高均價-最近9天最低價))*100[*RSV指未成熟隨機值]</li>
                            <li>資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=037">農業部農業資料開放平台</a></li>
                        </ul>
                    </b-col>

                </b-row>
                
                
            </b-container>

        </section>

        <!-- 彈出視窗(9日交易均價及成交量) -->
        <div v-show="modal.trade_price.show" class="w3-modal" style="display: block;">
            <div class="w3-modal-content w3-round-large">
                <div class="w3-container calculation">
                    <!-- 關閉按鈕 -->
                    <span class="w3-button w3-transparent w3-display-topright close-window-btn" @click="modal.trade_price.show = false;"><span class="icon-cross"></span></span>
                    <!-- 標題 -->
                    <h3 class="modal-title">{{ modal.trade_price.crop }}</h3>
                    <div class="w3-container">近9日交易均價及成交量。</div>
                    <!-- 圖表 -->
                    <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" >
                        <div id="chart_crop_trade_day9"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 彈出視窗(天氣小幫手描述") -->
        <div v-show="modal.open_weather_data.show" class="w3-modal" style="display: block;">
            <div class="w3-modal-content w3-round-large">
                <div class="w3-container calculation">
                    <!-- 關閉按鈕 -->
                    <span class="w3-button w3-transparent w3-display-topright close-window-btn" @click="modal.open_weather_data.show = false;"><span class="icon-cross"></span></span>
                    <!-- 標題 -->
                    <h3 class="modal-title">{{ modal.open_weather_data.title }}</h3>
                    <!-- 內容 -->
                    <div class="w3-container" v-html="modal.open_weather_data.content"></div>
                </div>
            </div>
        </div>
        
    </div>
    
</template>

<script>

export default {
    data() {
        return {
            weather: {
                date: "",
                place: "",
                MaxT: "",
                MinT: "",
                Wx: "",
                PoP: ""
            },
            //彈出視窗
            modal:{           
                //市場價格(9日折線圖)
                trade_price:{
                    //是否呈現
                    show:false,
                    //標題
                    title:" 近9日均價及成交量",
                    //作物
                    crop:"",
                },
                //天氣小幫手
                open_weather_data:{
                    //是否呈現
                    show:false,
                    //標題
                    title:" ",
                    //內容
                    content:"",
                    //時間
                    time:"",
                },
            },
            month: "",
            day: "",
            hour: "day",
            stationData: null,
            titleData: [],
            tableData: [],
            coltitle: ["旬別", "推估出苗量", "當旬警示燈號", "預定採收時間", "較近3年同期平均初苗量", "較近3年增減百分比"],
            upData: null,
            downData: null,
            farmData: null,
            farmData2: null,
            showmeteor: false,
            meteorIndex: "",
            meteorbtnIndex: 0,
            meteorData: null,
            meteorDataIndex: 0,
            meteorColorIndex: "tab-color-red  color-red",
            apiLineAuthorize: (data) => this.userRequest.post("/API/Default/LineAuthorize", data),  //Line登入專用

            apiGetHome: (data) => // 天氣、氣象觀測家、農價趨勢觀察家
                this.userRequest.get("API/Default/WelcomeYunLin", data),
            /*    
            apiGetCropTradeDay9: (data) => // 作物9日內均價、交易量
                this.userRequest.post("API/Default/CropTradeDay9", data),
            */
            apiGetCropTradeDay9: (data) => // 作物9日內均價、交易量
                this.userRequest.post("https://agri-data.kcg.gov.tw/Agri_API/Api/index/CropTradeDay9", data),    
            apiGetData: (data) => // 站台資料
                this.userRequest.get("../static/json/home.json", data),
            apiGetFarmData: (data) => // 智慧農業成果
                this.userRequest.get("../static/json/farm.json", data),
            apiGetMeteorData: (data) => // 氣象觀測家
                this.userRequest.get("../static/json/meteor.json", data),
            apiGetAnalysisData: (data) => // 甘藍產銷預警分析
                this.userRequest.get("https://data.moa.gov.tw/Service/OpenData/TransService.aspx?UnitId=KAKZOiDQJfKu", data),

            //api 取得智慧農場
            apiGetWisdomFarm: (data) => this.userRequest.get("/API/Default/GetWisdomFarm", data),

            //api 取得一般天氣預報-雲林縣天氣小幫手
            apiGetOpenWeatherData: (data) => this.userRequest.get("https://opendata.cwa.gov.tw/fileapi/v1/opendataapi/F-C0032-029?Authorization=CWB-3C60AC39-382B-4E08-A3E3-EEAFDFDFC94A&downloadType=WEB&format=JSON", data),


        };
    },
    components: {
    },
    updated() {
    },
    mounted() {
        this.addUserActionLog({

            TokenID:sessionStorage.getItem("TokenID"),
            WebPage:"首頁",
            WebAction:"走訪"
        });
        window.addEventListener("resize", this.checkScreenWidth);
        
        // 站台資料、智慧農業成果
        this.FunctionToken(this.getData, {});
        this.getGetWisdomFarm();
        var d = new Date();
        this.month = d.getMonth() + 1;
        this.day = d.getDate();
        let hours = d.getHours();
        if (hours >= 18) this.hour = "night";

        //確認是否由 Line 那邊導向過來的
        this.checkLineLogin();

        //以下先設定為null，因為會發生換頁時，他非null執行updateOptions會報錯，所以統一初始時，幫他設定Null
        //因為Vue是用元件切換，所以在換頁時，default_chart 並不會重載，只有整個重新整理才會重載，所以換頁時時常會出現錯誤
        window.ChartCropTradeDay9 = null;
        
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.checkScreenWidth); // 移除監聽器
    },
    methods: {

        //提示訊息(無連結時)
        total(url){
            if(url == "#")
            {
                alert("「頁面工事中，敬請期待。」");
            }
        },

        padLeft(str, lenght) {
            str = str.toString();
            if (str.length >= lenght)
                return str;
            else
                return this.padLeft("0" + str, lenght);
        },
        getData(data) {

            this.apiGetOpenWeatherData(data)
                    .then((res) => {

                    console.log(res.data);
                    //var parameterSetName = res.data.cwaopendata.dataset.parameterSet.parameterSetName;
                    //var parameter = res.data.cwaopendata.dataset.parameterSet.parameter;
                    //var time = this.formatDate(new Date(res.data.cwaopendata.dataset.datasetInfo.issueTime));

                    var parameterSetName = res.data.cwaopendata.Dataset.DatasetInfo.DatasetDescription;
                    var parameter = res.data.cwaopendata.Dataset.Locations.Location.WeatherElement.ElementValue.WeatherDescription;
                    var time = this.formatDate(new Date(res.data.cwaopendata.Dataset.DatasetInfo.IssueTime));
    
                    /*
                    if(parameter.length > 0)
                    {
                        this.modal.open_weather_data.title = parameterSetName;
                        for(var i=0 ; i<parameter.length ; i++)
                        {
                            this.modal.open_weather_data.content += "<p>" + parameter[i].parameterValue + "</p>";
                        }
                        this.modal.open_weather_data.content += "<p style=\"text-align: end;\">【更新時間:" + time + "】</p>";
                        this.modal.open_weather_data.show = true;
                    }
                    */

                    if(parameter.length > 0)
                    {
                        this.modal.open_weather_data.title = parameterSetName;
                        for(var i=0 ; i<parameter.length ; i++)
                        {
                            this.modal.open_weather_data.content += "<p>" + parameter[i] + "</p>";
                        }
                        this.modal.open_weather_data.content += "<p style=\"text-align: end;\">【更新時間:" + time + "】</p>";
                        this.modal.open_weather_data.show = true;
                    }

                })
                .catch((err) => {
                    console.log(err);
                });
            this.apiGetHome(data)
                .then((res) => {
                    const json = JSON.parse(res.data);
                    //console.log('apiGetHome=',json);
                    if (json) {
                        // 天氣
                        let weather_info = json.weather_info;
                        this.weather.date = json.date;
                        this.weather.place = weather_info.location;
                        this.weather.MaxT = weather_info.t_max;
                        this.weather.MinT = weather_info.t_min;
                        this.weather.Wx = this.padLeft(weather_info.wx, 2);
                        this.weather.PoP = weather_info.pop;
                        // 農價趨勢觀察家
                        this.upData = json.up_trend; // 漲勢作物
                        this.downData = json.down_trend; // 跌勢作物
                        // 氣象觀測家
                        let weather_warning = json.weather_warning;
                        const keyword = "注意";
                        const addword = "警戒";
                        const affectword = "可能影響-";
                        this.meteorData = [];// 氣象觀測家
                        for (let i = 0; i < weather_warning.length; i++) {
                            let detail = weather_warning[i].list;
                            let temp = { disaster: '', affect: '', color: '', datas: [] };
                            let disaster = weather_warning[i].disaster;
                            if (disaster.indexOf(keyword) !== -1) {
                                temp.disaster = disaster;
                                temp.color = "warning";
                            }
                            else {
                                temp.disaster = disaster + addword;
                                temp.color = "danger";
                            }

                            for (let j = 0; j < detail.length; j++) {
                                let tempdetail = { crop: '', content: '' };
                                if (j == 0) {
                                    if (disaster.indexOf(keyword) !== -1) {
                                        temp.affect = affectword + detail[j].disaster;
                                    }
                                    else {
                                        temp.affect = affectword + detail[j].disaster + addword;
                                    }
                                }

                                tempdetail.crop = detail[j].crop;
                                tempdetail.content = detail[j].effect;
                                temp.datas.push(tempdetail);
                            }
                            this.meteorData.push(temp);
                        }
                        this.meteorIndex = this.meteorData[0].disaster; // 設定 氣象觀測家
                    }
                    else { console.log('NO'); }
                })
                .catch((err) => {
                    console.log(err);
                });
            this.apiGetData(data)
                .then((res) => {
                    const json = res.data;
                    this.stationData = json.stationData; // 情報站
                })
                .catch((err) => {
                    console.log(err);
                });
            this.apiGetFarmData(data)
                .then((res) => {
                    const json = res.data;
                    this.farmData = json.farmData; // 智慧農業成果
                })
                .catch((err) => {
                    console.log(err);
                });
            this.apiGetAnalysisData(data)
                .then((res) => {
                    const json = res.data;
                    console.log(json);
                    // this.titleData = json.titleData; // 甘藍產銷預警分析
                    // this.tableData = json.tableData; // 甘藍產銷預警分析
                    var d = new Date();
                    var year_now = d.getFullYear() - 1911;
                    var month_now = d.getMonth() + 1;
                    var year_month_dArray = [{ year: year_now, month: month_now },
                    { year: year_now, month: month_now },
                    { year: year_now, month: month_now }];

                    if (month_now == 1) {
                        year_month_dArray[0].year = year_now - 1;
                        year_month_dArray[0].month = 10 + month_now;
                        year_month_dArray[1].year = year_now - 1;
                        year_month_dArray[1].month = 10 + month_now + 1;
                    }
                    else if (month_now == 2) {
                        year_month_dArray[0].year = year_now - 1;
                        year_month_dArray[0].month = 10 + month_now;
                        year_month_dArray[1].year = year_now;
                        year_month_dArray[1].month = month_now - 1;
                    }
                    else {
                        year_month_dArray[0].year = year_now;
                        year_month_dArray[0].month = month_now - 2;
                        year_month_dArray[1].year = year_now;
                        year_month_dArray[1].month = month_now - 1;
                    }
                    this.titleData = [];
                    this.tableData = [];
                    for (let i = 0; i < 3; i++) {
                        var count = 0;
                        for (let j = json.length - 1; j >= 0; j--) {
                            if (year_month_dArray[i].year == json[j].year && year_month_dArray[i].month == json[j].month) {
                                count++;
                                this.tableData.push(json[j]);
                            }
                            if (count == 3) break;
                        }

                        if (count > 0) {
                            var ym = year_month_dArray[i].year.toString() + "年" + year_month_dArray[i].month.toString() + "月";
                            this.titleData.push(ym);
                        }
                    }

                    // console.log('apiGetAnalysisData=', json, year_now, month_now, year_month_dArray, this.titleData, this.tableData);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getCropTradeDay9(crop) {

            this.enableMask();
            this.modal.trade_price.crop = crop;
            this.modal.trade_price.show = true;
            this.apiGetCropTradeDay9({

                CROP: this.modal.trade_price.crop ,
            })
            .then((res)=>{

                //var data = JSON.parse(res.data);
                //如果直接抓高雄的資料，則無需轉成json
                const data = res.data;
                if(data.length > 0)
                {
                    var column_week = [];
                    var line_week = [];
                    for(var i=0 ; i< data.length ; i++)
                    {
                        column_week.push({
                            //交易日期
                            x:data[i].T_DATE,
                            //交易量
                            y:this.getRounded(data[i].VOLUME)
                        });

                        line_week.push({
                            //交易日期
                            x:data[i].T_DATE,
                            //均價
                            y:this.getRounded(data[i].AVG)
                        });
                    }

                    window.ThreadTool.Delay(function(){
            
                        window.setChartCropTradeDay9("#chart_crop_trade_day9",{
                            column:column_week,
                            line:line_week
                        });

                    },1500);


                }

                this.disableMask();
            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });
        },
        //取得智慧農場
        getGetWisdomFarm:function()
        {
            this.soil = [];

            this.apiGetWisdomFarm({

            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                const list = data.list;
                this.farmData2 = [];
                for(var i=0;i < list.length ; i++){

                    var item = list[i];
                    this.farmData2.push({
                        title:item.name,
                        src:'https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_farm/' + item.sn + '/' + item.cover,
                        url:'FarmDetail/' + item.sn
                    });
                    console.log(item.name);
                }

            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });

        },        
        setmeteorIndex(num, type, color) {
            this.showmeteor = true;
            if (type == 'data') {
                this.meteorIndex = num;
                this.meteorbtnIndex = 0;
                this.meteorDataIndex = 0;
                if (color == 'warning')
                    this.meteorColorIndex = ' tab-color-yellow';
                else
                    this.meteorColorIndex = ' tab-color-red';
            }
            else {
                this.meteorDataIndex = num;
            }
        },
        tofarm(data) {
            console.log('tofarm', data);
            // this.$router.push({ path: '/FarmDetail', params: { id: '測試測' } });

        },
        closemeteor() {
            this.showmeteor = false;
        },
        //取得網址 Get 參數
        getSearchParams(key){

            var url = new URL(location.href);
            return url.searchParams.get(key);
        },

        //確認是否由 Line 那邊導向過來的
        checkLineLogin(){

            let state = this.getSearchParams("state");

            //備註:如果使用者在 [要求存取的項目] 點選 [許可] 會回傳
            //?code=mtruVeSQXetDxfAYH6QR&state=login
            let code = this.getSearchParams("code");

            //備註:如果使用者在 [要求存取的項目] 點選 [取消] 會回傳
            //?error=ACCESS_DENIED&state=login&error_description=The+resource+owner+denied+the+request.

            let error = this.getSearchParams("error");
            let error_description = this.getSearchParams("error_description");

            console.log(state);
            console.log(code);
            console.log(error);
            console.log(error_description);

            if(error == "ACCESS_DENIED"){

                alert("您好，必須允許雲林農業平台Line的權限，才能使用Line功能");         
                //備註:因為 IOS Safari 瀏覽器不支援 location.href，故改成 window.location
                //location.href = '.#/Login';
                window.location = '.#/Login';
                return false;
            }

            if(code != null && state!= null)
            {
                /* 測試OK - 帳號驗證(如果Line_User_ID 有則直接登入，如果沒有則建立新帳號後再登入) */     
                this.getLineAuthorize({
                    code:code,
                    state:state,
                });

            }
        },

        //取得 Line 身分驗證
        getLineAuthorize(data){

            this.apiLineAuthorize(data)
            .then((res)=>{
                const json = JSON.parse(res.data)

                let UserInfo = json.mAgriUserInfo;

                let AC_ID = UserInfo.AC_ID;
                let AC_USERID = UserInfo.AC_USERID;
                let AC_USERNAME = UserInfo.AC_USERNAME;
                let AC_PWD = UserInfo.AC_PWD;
                let AC_USERTYPE = UserInfo.AC_USERTYPE;
                let AC_STATUS = UserInfo.AC_STATUS;
                let AC_GROUP_ID = UserInfo.AC_GROUP_ID;
                let AC_TITLE = UserInfo.AC_TITLE;
                let AC_TEL_EX = UserInfo.AC_TEL_EX;
                let AC_KEYID = UserInfo.AC_KEYID;
                let AC_SEX = UserInfo.AC_SEX;
                let AC_IDNUM = UserInfo.AC_IDNUM;
                let AC_BIRTHDAY = UserInfo.AC_BIRTHDAY;
                let AC_CONTACT = UserInfo.AC_CONTACT;
                let AC_POST = UserInfo.AC_POST;
                let AC_CITYID = UserInfo.AC_CITYID;
                let AC_TOWNID = UserInfo.AC_TOWNID;
                let AC_ADDRESS = UserInfo.AC_ADDRESS;
                let AC_TEL = UserInfo.AC_TEL;
                let AC_MOBILE = UserInfo.AC_MOBILE;
                let AC_FAX = UserInfo.AC_FAX;
                let AC_EMAIL = UserInfo.AC_EMAIL;
                let AC_CONTENT = UserInfo.AC_CONTENT;
                let AC_IMG = UserInfo.AC_IMG;
                let AC_ORDER = UserInfo.AC_ORDER;
                let AC_VCOUNT = UserInfo.AC_VCOUNT;
                let AC_MDATE = UserInfo.AC_MDATE;
                let AC_EDATE = UserInfo.AC_EDATE;
                let AC_EUSER = UserInfo.AC_EUSER;
                let AC_LOGINSET = UserInfo.AC_LOGINSET;
                let AC_ISDEL = UserInfo.AC_ISDEL;
                let AC_NOTIFY = UserInfo.AC_NOTIFY;
                let AC_ERROR_TIME = UserInfo.AC_ERROR_TIME;
                let AC_ERROR_COUNT = UserInfo.AC_ERROR_COUNT;
                let AC_LINE_USER_ID = UserInfo.AC_LINE_USER_ID;

                let UserName = UserInfo.UserName;
                let TokenID = UserInfo.TokenID;
                let DisposableLine = UserInfo.DisposableLine;

                console.log(AC_ID);
                console.log(AC_USERID);
                console.log(AC_USERNAME);
                console.log(AC_PWD);
                console.log(AC_USERTYPE);
                console.log(AC_STATUS);
                console.log(AC_GROUP_ID);
                console.log(AC_TITLE);
                console.log(AC_TEL_EX);
                console.log(AC_KEYID);
                console.log(AC_SEX);
                console.log(AC_IDNUM);
                console.log(AC_BIRTHDAY);
                console.log(AC_CONTACT);
                console.log(AC_POST);
                console.log(AC_CITYID);
                console.log(AC_TOWNID);
                console.log(AC_ADDRESS);
                console.log(AC_TEL);
                console.log(AC_MOBILE);
                console.log(AC_FAX);
                console.log(AC_EMAIL);
                console.log(AC_CONTENT);
                console.log(AC_IMG);
                console.log(AC_ORDER);
                console.log(AC_VCOUNT);
                console.log(AC_MDATE);
                console.log(AC_EDATE);
                console.log(AC_EUSER);
                console.log(AC_LOGINSET);
                console.log(AC_ISDEL);
                console.log(AC_NOTIFY);
                console.log(AC_ERROR_TIME);
                console.log(AC_ERROR_COUNT);
                console.log(AC_LINE_USER_ID);

                console.log(UserName);
                console.log(TokenID);
                console.log(DisposableLine);

                sessionStorage.setItem("TokenID", TokenID);
                sessionStorage.setItem("username", UserName);
                sessionStorage.setItem("AC_GROUP_ID", AC_GROUP_ID);
                
                if(Number(DisposableLine) == 1){

                    sessionStorage.setItem("disposable_line", "1");
                }

                //修正 Line導向網址的設定 By 2023_12_05
                /*
                this.$parent.refresh();
                this.$router.push({ path: "/" });
                window.history.forward(1);
                //location.href = "/";
                window.location.replace("/");
                //window.location.reload();
                */
               
                if(data.state != null && data.state == "login_pwa")
                {
                    this.$parent.refresh();
                    window.location = "pwa.html#/PwaHome";
                    return false;
                }


                var backurl_local = localStorage.getItem("backurl");
                if(backurl_local != null && backurl_local.trim().toUpperCase() == "PWA")
                {
                    localStorage.removeItem("backurl");
                    this.$parent.refresh();
                    //this.$router.push({ "pwa.html#/PwaHome" });
                    //因為導向時，會殘留參數，故改成如下 
                    window.location = "pwa.html#/PwaHome";

                }else{

                    var backurl = sessionStorage.getItem("backurl");
                    if(backurl != null)
                    {
                        sessionStorage.removeItem("backurl");
                        this.$parent.refresh();
                        //this.$router.push({ path: "/" + backurl });
                        //因為導向時，會殘留參數，故改成如下
                        window.location = '.#/' + backurl;
                    }
                    else
                    {
                        this.$parent.refresh();
                        //this.$router.push({ path: "/" });
                        window.location = '.#/';
                    }
                }

            })
            .catch((err)=> {
                console.log(err)
            });   
        },

        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },

        //時間轉換字串 (格式:yyyy-mm-dd hh:mm:ss)
        formatDate(date) {
            return (
                [
                date.getFullYear(),
                this.padTo2Digits(date.getMonth() + 1),
                this.padTo2Digits(date.getDate()),
                ].join('-') +
                ' ' +
                [
                this.padTo2Digits(date.getHours()),
                this.padTo2Digits(date.getMinutes()),
                this.padTo2Digits(date.getSeconds()),
                ].join(':')
            );
        }

    },
    watch: {
    }
};
</script>

<style scoped>

/** 作物9日內均價、交易量 */
#chart_crop_trade_day9{

    min-width: 800px;
}
</style>

